"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const Input = (0, _styled.default)("input")`
    opacity: 0;
    width: 48px;
    height: 24px;
    position: absolute;
    cursor: inherit;

    // UA reset to ensure the virtual cursor is properly positioned for screen readers.
    margin: 0;
    padding: 0;

    &:focus {
        outline: none !important;
    }
`;
exports.Input = Input;
//# sourceMappingURL=Input.js.map